<template>
  <div class="vacancies">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">

          <!-- Page Header -->
          <div class="page-header">
            <div class="d-flex justify-content-between">
              <div class="col">
                <h3 class="page-title"><b v-if="review.employee">{{
                                            `${review.employee.firstName} ${review.employee.lastName}`
                                            }}</b> Review Detail</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item active">Review</li>
                </ul>
              </div>
              <div class="col-auto float-right ml-auto">
                  <router-link v-if="review.employee" :to="{name: 'employeeGoals', params: {id: review.employee.id}}"
                                            class="btn add-btn"
                                            
                                            ><i class="fa fa-pencil m-r-5"></i> Goal Detail</router-link
                                            >
              </div>
            </div>
          </div>
          <!-- /Page Header -->

          <div class="row">
            <div class="col-md-12">
                <div class="col-md-12">
                                                <div
                                                class="alert alert-danger alert-dismissible fade show"
                                                role="alert"
                                                v-if="error"
                                                >
                                                <strong>Error!</strong> {{ error }}
                                                <button
                                                    type="button"
                                                    class="close"
                                                    data-dismiss="alert"
                                                    aria-label="Close"
                                                >
                                                    <span aria-hidden="true">&times;</span>
                                                </button>
                                                </div>
                                            </div>
                                            <div class="col-md-12">
                                                <div
                                                class="alert alert-success alert-dismissible fade show"
                                                role="alert"
                                                v-if="message"
                                                >
                                                <strong>Success!</strong> {{ message }}
                                                <button
                                                    type="button"
                                                    class="close"
                                                    data-dismiss="alert"
                                                    aria-label="Close"
                                                >
                                                    <span aria-hidden="true">&times;</span>
                                                </button>
                                                </div>
                                            </div>
                <div class="col-md-12">
                    <div class="accordion" id="accordionExample">
                        <div class="card mb-3">
                            <div class="card-header" id="headingOne">
                            <h5 class="mb-0 d-flex justify-content-between collapsed" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                <button class="btn collapsed">
                                    Appraisee Comments
                                </button>
                                <span class="collapsed menu-arrow">
                                    <i class="la la-chevron-down icon-dropdown"></i> 
                                </span>
                            </h5>
                            </div>

                            <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                            <div class="card-body">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label
                                                >Comment <span class="text-danger">*</span></label
                                                >
                                                <textarea type="text" rows="5" cols="7" class="form-control" v-model="review.employeeComment" disabled>
                                                </textarea>
                                            </div>
                                        </div>
                                    </div>
                           </div>
                        </div>
                        </div>
                        <div class="card mb-3">
                            <div class="card-header" id="headingTwo">
                            <h5 class="mb-0 d-flex justify-content-between collapsed" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
                                <button class="btn collapsed">
                                    Appraisee Comments
                                </button>
                                <span class="collapsed menu-arrow">
                                    <i class="la la-chevron-down icon-dropdown"></i> 
                                </span>
                            </h5>
                            </div>

                            <div id="collapseTwo" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                            <div class="card-body">
                                    <div class="d-flex justify-content-between mt-1" v-if="type == 1 && review.status == 1">
                                    <div></div>
                                    <a class="btn text-primary float-right mr-3" @click="onAppraisalSubmit">
                                        <i class="la la-check"></i> Save
                                    </a>
                                </div>
                                <hr class="mt-1"  v-if="type == 1 && review.status == 1" />
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label
                                                >Training Recommendation <span class="text-danger">*</span></label
                                                >
                                                <textarea type="text" rows="5" cols="7" class="form-control" v-model="review.trainingRecommendation" :disabled="(type > 1 || type < 1) && (review.status > 1 || review.status < 1)">
                                                </textarea>
                                            </div>
                                            <div class="form-group">
                                                <label
                                                >Comment <span class="text-danger">*</span></label
                                                >
                                                <textarea type="text" rows="5" cols="7" class="form-control" v-model="review.appraisalComment"  :disabled="(type > 1 || type < 1) && (review.status > 1 || review.status < 1)">
                                                </textarea>
                                            </div>
                                            <div class="form-group">
                                                <label>
                                                    Recommendation <span class="text-danger">*</span>
                                                </label>
                                                <select placeholder="Select Employee" class="form-control" v-model="review.recommendation" :disabled="(type > 1 || type < 1) && (review.status > 1 || review.status < 1)">
                                                <option value="">Select Recomendation</option>
                                                <option>Promotion</option>
                                                <option>Lateral Transfer</option>
                                                <option>Remain in Present Job</option>
                                                <option>Confirmation</option>
                                                <option>Termination</option>
                                                <option>Conversion</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                           </div>
                        </div>
                        </div>
                        <div class="card mb-3">
                            <div class="card-header" id="headingThree">
                            <h5 class="mb-0 d-flex justify-content-between collapsed" data-toggle="collapse" data-target="#collapseThree" aria-expanded="true" aria-controls="collapseThree">
                                <button class="btn collapsed">
                                    HR Comments
                                </button>
                                <span class="collapsed menu-arrow">
                                    <i class="la la-chevron-down icon-dropdown"></i> 
                                </span>
                            </h5>
                            </div>

                            <div id="collapseThree" class="collapse show" aria-labelledby="headingThree" data-parent="#accordionExample">
                            <div class="card-body">
                                    
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label
                                                >Comment <span class="text-danger">*</span></label
                                                >
                                                <textarea type="text" rows="5" cols="7" class="form-control" v-model="review.hrComment" disabled>
                                                </textarea>
                                            </div>
                                        </div>
                                    </div>
                           </div>
                        </div>
                        </div>
                        <div class="card mb-3">
                            <div class="card-header" id="headingFour">
                            <h5 class="mb-0 d-flex justify-content-between collapsed" data-toggle="collapse" data-target="#collapseFour" aria-expanded="true" aria-controls="collapseFour">
                                <button class="btn collapsed">
                                    Management Comments
                                </button>
                                <span class="collapsed menu-arrow">
                                    <i class="la la-chevron-down icon-dropdown"></i> 
                                </span>
                            </h5>
                            </div>

                            <div id="collapseFour" class="collapse show" aria-labelledby="headingFour" data-parent="#accordionExample">
                            <div class="card-body">
                                    <div class="d-flex justify-content-between mt-1" v-if="type == 3 && review.status == 3">
                                    <div></div>
                                    <a class="btn text-primary float-right mr-3" @click="onMgtSubmit">
                                        <i class="la la-check"></i> Save
                                    </a>
                                </div>
                                <hr class="mt-1" v-if="type == 3 && review.status == 3"/>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label
                                                >Comment <span class="text-danger">*</span></label
                                                >
                                                <textarea type="text" rows="5" cols="7" class="form-control" v-model="review.mgtComment" :disabled="(type > 3 || type < 3) && review.status == 3">
                                                </textarea>
                                            </div>
                                        </div>
                                    </div>
                           </div>
                        </div>
                        </div>


                    </div>
                </div>
            </div>
        </div>
          <!-- /Page Content -->
        </div>
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/employeeSidebar.vue";
import { authenticationService } from '@/services/authenticationService';
import { performanceService } from '@/services/performanceService';
import { employeeService } from '@/services/employeeService';
import { organizationService } from '@/services/organizationService';
import Datepicker from "vuejs-datepicker";
import { required, sameAs } from "vuelidate/lib/validators";

export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Datepicker
  },
  data() {
      return {
        dialog: false,
        reviewId: this.$route.params.id,
        type: this.$route.query.type,
        currentUser: authenticationService.currentUserValue,
        review: {
            goals: []
        },
		message: '',
		error: '',
    }
   },
  mounted() {

        this.getReview()
        console.log(this.type)
        if ($('.datatable').length > 0) {
            $('.datatable').DataTable({
            "bFilter": false,
            });
        }
  },

  methods: {
    getReview () {
      performanceService.getReview(this.reviewId)
          .then(
            model => { 
            this.review = model
            console.log(model) },
            error => { error = error }
          )
    },
    onEmployeeSubmit() {
        this.submitted = true;
      this.loading = true;
            performanceService.updateReview(this.reviewId, this.review).then(
            m => {
                this.message = "Review have been updated successful"
                this.getReview();
            },
            error => {
                this.error = error
            }
        )
    },
    onAppraisalSubmit() {
        this.submitted = true;
      this.loading = true;
        this.review.appraisal = this.currentUser.employee.firstName + ' ' + this.currentUser.employee.lastName
        this.review.appraisalCommentDate = new Date();
        this.review.status = 2
            performanceService.updateReview(this.reviewId, this.review).then(
            m => {
                this.message = "Review have been updated successful"
                this.getReview();
            },
            error => {
                this.error = error
            }
        )
    },
    onHRSubmit() {
        this.submitted = true;
      this.loading = true;
        this.review.hr = this.currentUser.employee.firstName + ' ' + this.currentUser.employee.lastName
        this.review.hrCommentDate = new Date();
        this.review.status = 3
            performanceService.updateReview(this.reviewId, this.review).then(
            m => {
                this.message = "Review have been updated successful"
                this.getReview();
            },
            error => {
                this.error = error
            }
        )
    },
    onMgtSubmit() {
        this.submitted = true;
      this.loading = true;
        this.review.mgt = this.currentUser.employee.firstName + ' ' + this.currentUser.employee.lastName
        this.review.mgtCommentDate = new Date();
        this.review.status = 5
            performanceService.updateReview(this.reviewId, this.review).then(
            m => {
                this.message = "Review have been updated successful"
                this.getReview();
            },
            error => {
                this.error = error
            }
        )
    },
  },
  name: "reviews"
};
</script>
<style scoped>

.datatable > thead > tr > th,
.datatable > tbody > tr > td {
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>


// WEBPACK FOOTER //
// src/components/review/reviewDetail.vue